<template>
    <div class="w-full shrink-0 px-2 pb-2 md:mx-auto md:max-w-(--breakpoint-md) md:px-4">
        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <BaseButton theme="neutral" class="w-full justify-center rounded-lg sm:w-auto" :disabled="disabled" :aria-label="keepEditingAriaLabel" @click="emit('keep-editing')">
                {{ keepEditingLabel }}
            </BaseButton>
            <BaseButton ref="lockInButton" theme="primary" class="w-full justify-center sm:w-auto" :disabled="disabled" :aria-label="lockInAriaLabel" @click="emit('lock-in')">
                {{ lockInLabel }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useTemplateRef } from "vue";

withDefaults(defineProps<{ disabled?: boolean; keepEditingLabel?: string; lockInLabel?: string; keepEditingAriaLabel?: string; lockInAriaLabel?: string }>(), {
    disabled: false,
    keepEditingLabel: "Keep editing",
    lockInLabel: "Lock it in",
});
const emit = defineEmits<{ "keep-editing": []; "lock-in": [] }>();

const lockInButton = useTemplateRef<InstanceType<typeof BaseButton>>("lockInButton");
defineExpose({ focusLockIn: () => (lockInButton.value?.$el as HTMLButtonElement | undefined)?.focus() });
</script>
